import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

// Pages
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardLayout from "./layouts/DashboardLayout";
import DashboardHome from "./pages/dashboard/DashboardHome";
import AltaSocios from "./pages/dashboard/AltaSocios";
import MiPerfilSocio from "./pages/dashboard/MiPerfilSocio";
import GuiaProfesionales from "./pages/dashboard/GuiaProfesionales";
import Tramites from "./pages/dashboard/Tramites";
import ECommerce from "./pages/dashboard/ECommerce";
import Eventos from "./pages/dashboard/Eventos";
import ELearning from "./pages/dashboard/ELearning";
import Biblioteca from "./pages/dashboard/Biblioteca";
import PanelInterno from "./pages/dashboard/PanelInterno";
import GestionUsuarios from "./pages/dashboard/GestionUsuarios";
import PresupuestoFinanciero from "./pages/dashboard/PresupuestoFinanciero";

// ERP Pages
import Contabilidad from "./pages/dashboard/erp/Contabilidad";
import Tesoreria from "./pages/dashboard/erp/Tesoreria";
import Stock from "./pages/dashboard/erp/Stock";
import Compras from "./pages/dashboard/erp/Compras";
import CuentasCorrientes from "./pages/dashboard/erp/CuentasCorrientes";
import Ejercicios from "./pages/dashboard/erp/Ejercicios";
import ImportacionSaldos from "./pages/dashboard/erp/ImportacionSaldos";
import FacturacionElectronica from "./pages/dashboard/erp/FacturacionElectronica";
import AjusteInflacion from "./pages/dashboard/erp/AjusteInflacion";
import ReportesContables from "./pages/dashboard/erp/ReportesContables";
import ArqueoCaja from "./pages/dashboard/erp/ArqueoCaja";
import Cotizaciones from "./pages/dashboard/erp/Cotizaciones";
import ConciliacionBancaria from "./pages/dashboard/erp/ConciliacionBancaria";
import GestionCobranzas from "./pages/dashboard/erp/GestionCobranzas";
import GestionPagos from "./pages/dashboard/erp/GestionPagos";
import FondoFijo from "./pages/dashboard/erp/FondoFijo";
import GestionUTEs from "./pages/dashboard/erp/GestionUTEs";
import SuperadminTenants from "./pages/dashboard/SuperadminTenants";

// Auth context
import { AuthProvider, useAuth } from "./context/AuthContext";
import { TenantProvider } from "./context/TenantContext";

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F6F8FA]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#2853B9]"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <TenantProvider>
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            
            {/* Protected dashboard routes */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }>
              <Route index element={<DashboardHome />} />
              <Route path="alta-socios" element={<AltaSocios />} />
              <Route path="mi-perfil" element={<MiPerfilSocio />} />
              <Route path="guia-profesionales" element={<GuiaProfesionales />} />
              <Route path="tramites" element={<Tramites />} />
              <Route path="e-commerce" element={<ECommerce />} />
              <Route path="eventos" element={<Eventos />} />
              <Route path="e-learning" element={<ELearning />} />
              <Route path="biblioteca" element={<Biblioteca />} />
              <Route path="interno" element={<PanelInterno />} />
              <Route path="usuarios" element={<GestionUsuarios />} />
              <Route path="presupuesto" element={<PresupuestoFinanciero />} />
              
              {/* ERP Routes */}
              <Route path="erp/contabilidad" element={<Contabilidad />} />
              <Route path="erp/tesoreria" element={<Tesoreria />} />
              <Route path="erp/stock" element={<Stock />} />
              <Route path="erp/compras" element={<Compras />} />
              <Route path="erp/cuentas-corrientes" element={<CuentasCorrientes />} />
              <Route path="erp/ejercicios" element={<Ejercicios />} />
              <Route path="erp/importacion-saldos" element={<ImportacionSaldos />} />
              <Route path="erp/facturacion" element={<FacturacionElectronica />} />
              <Route path="erp/ajuste-inflacion" element={<AjusteInflacion />} />
              <Route path="erp/reportes" element={<ReportesContables />} />
              <Route path="erp/arqueo-caja" element={<ArqueoCaja />} />
              <Route path="erp/cotizaciones" element={<Cotizaciones />} />
              <Route path="erp/conciliacion-bancaria" element={<ConciliacionBancaria />} />
              <Route path="erp/cobranzas" element={<GestionCobranzas />} />
              <Route path="erp/pagos" element={<GestionPagos />} />
              <Route path="erp/fondo-fijo" element={<FondoFijo />} />
              <Route path="erp/utes" element={<GestionUTEs />} />
              <Route path="superadmin/tenants" element={<SuperadminTenants />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster 
          position="top-right" 
          richColors 
          closeButton
          toastOptions={{
            style: {
              fontFamily: "Public Sans, sans-serif",
            },
          }}
        />
      </div>
    </AuthProvider>
    </TenantProvider>
  );
}

export default App;
